import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicFormServiceService } from 'src/app/shared/services/dynamic-form-service.service';
import { OrderFieldConfig } from 'src/app/core/classes/orderFieldConfig';
import { Constants } from 'src/app/shared/constants';
import { PropertyName } from 'src/app/core/enumerations/sectionNames';

@Component({
    selector: 'app-input-comp',
    templateUrl: './input-comp.component.html',
    styleUrls: ['./input-comp.component.scss'],
    standalone: false
})
export class OrderInputCompComponent implements OnInit {
  hyphenPositions: any[];
  displayNoneLabportSpecCode = false;

  constructor(private dynamicService: DynamicFormServiceService) { }
  field: OrderFieldConfig;
  group: UntypedFormGroup;
  isRequired: boolean;
  maxLength: number;
  displayMinLengthError = false;
  required = Constants.IS_REQUIRED;

  ngOnInit() {
    if (this.field.labelCode === PropertyName.LabportSpecimenCode || this.field.labelCode === PropertyName.SpecimenId) {
      this.displayNoneLabportSpecCode = true;
    }
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
    if (this.field.displayFormat) {
      this.group.get(this.field.labelCode).setValidators([
        Validators.minLength(this.field.displayFormat.length),
        Validators.maxLength(this.field.displayFormat.length),
        this.verifyKitIdRegex(this.field.displayFormat)]);
      this.maxLength = this.field.displayFormat.length;
      this.group.get(this.field.labelCode).updateValueAndValidity();
      this.group.get(this.field.labelCode).valueChanges.subscribe(res => {
        const error = this.group.get(this.field.labelCode).errors && this.group.get(this.field.labelCode).errors.minlength;
        this.displayMinLengthError = !!(error && error.requiredLength !== error.actualLength);
      });
      this.field.hyphenPositions = this.getHyphenPosition(this.field.displayFormat);
    }
  }

  private verifyKitIdRegex(displayFormat: string) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (!displayFormat || !control.value || displayFormat.length !== control.value.length) {
        return null;
      }

      const errorCount = this.countFormatMismatches(control.value, displayFormat);
      return errorCount === 0 ? null : { displayFormatError: true };
    };
  }

  private countFormatMismatches(enteredValue: string, displayFormat: string): number {
    let count = 0;
    const enteredValueArray = Array.from(enteredValue);
    const formatArray = Array.from(displayFormat);

    if (enteredValueArray.length === 0 || formatArray.length === 0) {
      return count;
    }

    for (let i = 0; i < formatArray.length; i++) {
      if (!this.isFormatCharacterValid(formatArray[i], enteredValueArray[i])) {
        count++;
      }
    }
    return count;
  }

  private isFormatCharacterValid(formatChar: string, enteredChar: string): boolean {
    if (formatChar === '@') {
      return /[a-zA-Z0-9]/.test(enteredChar);
    } else if (formatChar === '#') {
      return /[0-9*]/.test(enteredChar);
    } else if (formatChar === '-') {
      return enteredChar === '-';
    } else if (/\d/.test(formatChar)) {
      return formatChar === enteredChar;
    } else if (/[a-zA-Z]/.test(formatChar)) {
      return formatChar.toLowerCase() === enteredChar.toLowerCase();
    }
    return formatChar === enteredChar;
  }

  private getHyphenPosition(displayFormat) {
    let flag = 0;
    const indices = [];
    for (let i = 0; i < displayFormat.length; i++) {
      if (displayFormat[i] === '-') {
        if (flag === 0) {
          indices.push(i);
          flag++;
        } else {
          indices.push(i);
        }
      }
    }

    return indices;
  }
}
